<template>
	<div id="vue-footer" class="footer-content">
		<mobile-app-callout class="hide-desktop" />

		<div class="hide-mobile">
			<footer-quick-links />

			<!----------------- Desktop ----------------->

			<div class="footer-content-top desktop container flex flex-between">
				<sign-up-section id-prefix="desktop">
					<a :href="newsweekArticleUrl" class="footer-content-newsweek footer-content-newsweek--long mt-lg hide-desktop">
						<img
							:src="`/assets/images/misc/Newsweek_BOS2026_Logo_Hor.png`"
							alt="Newsweek America's Best Online Shops 2026"
							loading="lazy"
							width="225"
							height="113"
						/>
					</a>
				</sign-up-section>
				<a :href="newsweekArticleUrl" class="footer-content-newsweek footer-content-newsweek--tall">
					<img
						:src="`/assets/images/misc/Newsweek_BOS2026_Logo_Basic.png`"
						alt="Newsweek America's Best Online Shops 2026"
						loading="lazy"
						width="130"
						height="224"
					/>
				</a>
				<services-links />
				<company-links />
				<customer-care-links />
				<store-summary :store="localStore" />
			</div>

			<!----------------- Tablet ----------------->

			<div class="footer-content-top tablet">
				<div class="flex flex-between mb-lg">
					<sign-up-section id-prefix="tablet" />
					<a :href="newsweekArticleUrl" class="footer-content-newsweek">
						<img
							:src="`/assets/images/misc/Newsweek_BOS2026_Logo_Basic.png`"
							alt="Newsweek America's Best Online Shops 2026"
							loading="lazy"
							width="130"
							height="224"
						/>
					</a>
					<store-summary :store="localStore" />
				</div><br />
				<div class="flex flex-between mt-lg">
					<services-links />
					<company-links />
					<customer-care-links />
				</div>
			</div>
		</div>

		<!----------------- Mobile ----------------->

		<mobile-footer
			class="show-mobile"
			:store="localStore"
		/>

	</div>
</template>

<script>
import CompanyLinks from './CompanyLinks.vue';
import CustomerCareLinks from './CustomerCareLinks.vue';
import FooterQuickLinks from './shared/FooterQuickLinks.vue';
import MobileAppCallout from './mobile/MobileAppCallout.vue';
import MobileFooter from './mobile/MobileFooter.vue';
import ServicesLinks from './ServicesLinks.vue';
import SignUpSection from './shared/SignUpSection.vue';
import StoreSummary from './StoreSummary.vue';
import vueEventBus from '../../global/vue-event-bus.js';
export default {
	name: 'FooterApp',
	components: {
		CompanyLinks,
		CustomerCareLinks,
		FooterQuickLinks,
		ServicesLinks,
		MobileAppCallout,
		MobileFooter,
		SignUpSection,
		StoreSummary,
	},
	data() {
		return {
			isMobileDevice: false,
			localStore: null,
			newsweekArticleUrl: 'https://www.farmandfleet.com/blog/blains-farm-fleet-2026-awards/',
		};
	},
	methods: {
		init(vm) {
			if (!vm) return;
			this.isMobileDevice = vm.isMobileDevice;
			this.localStore = vm.localStoreJson;
		},
		eventBusListen() {
			if (!window) return;
			if (!window.vueEventBus) window.vueEventBus = vueEventBus;
			window.vueEventBus.$on('footer-vm', vm => this.init(vm));
		}
	},
	mounted() {
		if (!window) return;
		window.footerJson ? this.init(window.footerJson) : this.eventBusListen();
	}
};
</script>

<style lang="less">
@import '../../../less/_mixins.less';

.footer-content {
	//background-color: #F2F3F8;
}

.footer-content-top {
	border-top: 1px solid #CBD0E4;

	.footer-links-list {
		a, .link-button {
			color: #000000DE;
			display: block;
			font-size: 0.875rem;
			margin-bottom: 8px;
			text-decoration: none;
			line-height: 1.25;
			&:hover {
				text-decoration: underline;
			}
		}
	}
	.footer-email-signup {
		flex: 0 1 300px;
	}
}

.footer-content-top.desktop {
	padding: 35px 15px;
	display: none;

	@media only screen and (min-width: 1025px) {
		display: flex;
	}

	.styles-at(1180px, {
		.footer-content-newsweek {
			display: none;
		}
		.footer-email-signup .footer-content-newsweek {
			display: block !important;
			margin: 20px auto 0 auto;
		}
	});
}

.footer-content-top.tablet {
	display: none;
	margin: 0 auto;
	max-width: 720px;
	padding: 32px 20px 32px 20px;

	@media only screen and (min-width: @tablet-min) and (max-width: @desktop-min) {
		display: block;
	}
}

.footer-content-signup {
	flex: 0 1 520px;
}

.footer-content-newsweek {
	max-width: 260px;

	img {
		width: 100%;
	}

	&--long {
		height: 100px;
		aspect-ratio: 2.6;

		img {
			height: 100px
		}
	}

	&--tall {
		height: 210px;
		aspect-ratio: 0.61;

		img {
			height: 210px;
		}
	}
}

.footer-divider {
	background-color: #CBD0E4;
	height: 1px;
	margin: 16px 15px 16px 0px;
}

.footer-links-list {
	h2 {
		color: #000000DE;
		font-size: 1rem;
		font-weight: bold;
		margin-bottom: 16px;
	}
}

//Legal section
.footer-bottom {
	background-color: #F5F5F5;
	padding: 15px;
	text-align: center;

	&__links {
		justify-content: center;
		margin-bottom: 12px;
		display: flex;
		flex-wrap: wrap;
		column-gap: 12px;
		row-gap: 8px;

		.tablet-and-up-styles({
			column-gap: 16px;
		});

	}

	&__link {
		color: @BB;
		display: inline-block;
		font-size: 0.875rem;
		line-height: 1.25;
		text-decoration: none;
		text-wrap: nowrap;

		.mobile-styles({
			font-size: 0.75rem;
		});
	}

	&__copy {
		color: #00000099;
		font-size: 0.75rem;
		line-height: 1.25;
		margin-bottom: 0px;
	}
}
</style>